"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var FontAwesome5_1 = __importDefault(require("react-native-vector-icons/FontAwesome5"));

var error_panel_content_1 = require("../../../../theming/pricing-system/error-panel.content");

var error_panel_style_1 = require("../../../../theming/pricing-system/error-panel.style");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var primary_text_box_1 = require("../../../text/primary-text-box/primary-text-box");

var button_1 = require("../../buttons/button/button");

var panel_1 = require("../panel/panel");

var ErrorPanel = function (_super) {
  __extends(ErrorPanel, _super);

  function ErrorPanel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ErrorPanel.prototype.render = function () {
    if (!this.props.contextId && !this.props.message) {
      return null;
    }

    var heading = this.props.heading || error_panel_content_1.ErrorPanelContent.defaultHeading;
    var messageContent = this.props.message ? this.renderCustomError() : this.renderGenericError();
    var headingTextStyle = this.props.onClose ? theme_pricing_system_1.pricingStyles.errorPanelHeadingTextStyle : theme_pricing_system_1.pricingStyles.errorPanelHeadingWhenNoCloseTextStyle;
    return react_1.default.createElement(panel_1.Panel, {
      heading: heading,
      viewStyle: [theme_pricing_system_1.pricingStyles.errorPanelViewStyle, this.props.viewStyle],
      headingTextStyle: headingTextStyle
    }, messageContent, this.renderCloseButton(), this.renderContext());
  };

  ErrorPanel.prototype.timestamp = function () {
    return new Date();
  };

  ErrorPanel.prototype.renderGenericError = function () {
    return react_1.default.createElement(primary_text_box_1.PrimaryTextBox, {
      caption: error_panel_content_1.ErrorPanelContent.contactSupport,
      textBoxStyle: theme_pricing_system_1.pricingStyles.errorPanelTextStyle
    });
  };

  ErrorPanel.prototype.renderCustomError = function () {
    if (typeof this.props.message !== 'string') {
      return this.props.message;
    }

    return react_1.default.createElement(primary_text_box_1.PrimaryTextBox, {
      caption: this.props.message,
      textBoxStyle: theme_pricing_system_1.pricingStyles.errorPanelTextStyle
    });
  };

  ErrorPanel.prototype.renderContext = function () {
    var timestampAsString = this.timestamp().toLocaleString();
    return react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.errorPanelContextViewStyle
    }, this.renderContextId(), react_1.default.createElement(primary_text_box_1.PrimaryTextBox, {
      caption: timestampAsString,
      textBoxStyle: theme_pricing_system_1.pricingStyles.errorPanelTimestampTextStyle
    }));
  };

  ErrorPanel.prototype.renderContextId = function () {
    if (!this.props.contextId) {
      return null;
    }

    var content = error_panel_content_1.ErrorPanelContent.contextId + " " + this.props.contextId;
    return react_1.default.createElement(primary_text_box_1.PrimaryTextBox, {
      caption: content,
      textBoxStyle: theme_pricing_system_1.pricingStyles.errorPanelContextIdTextStyle
    });
  };

  ErrorPanel.prototype.renderCloseButton = function () {
    if (!this.props.onClose) {
      return null;
    }

    var buttonLabel = react_1.default.createElement(FontAwesome5_1.default, {
      name: "times",
      size: error_panel_style_1.errorPanelCloseIconSize
    });
    return react_1.default.createElement(button_1.Button, {
      label: buttonLabel,
      onPress: this.props.onClose,
      type: "icon",
      iconText: error_panel_content_1.ErrorPanelContent.closeIconAccessibilityText,
      viewStyle: theme_pricing_system_1.pricingStyles.errorPanelCloseButtonViewStyle,
      textStyle: theme_pricing_system_1.pricingStyles.errorPanelCloseButtonTextStyle
    });
  };

  return ErrorPanel;
}(react_1.default.Component);

exports.ErrorPanel = ErrorPanel;